/* eslint-disable no-undef */
const lightboxThumbnailImg = require("./assets/images/image-product-2-thumbnail.jpg");

export const products = [
  {
    id: 1,
    name: "Fall Limited Edition Sneakers",
    price: 125,
    image: lightboxThumbnailImg,
  },
];
